import { render, staticRenderFns } from "./rolesEditor.vue?vue&type=template&id=408d9e9b&scoped=true&"
import script from "./rolesEditor.vue?vue&type=script&lang=js&"
export * from "./rolesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d9e9b",
  null
  
)

export default component.exports